// FormSection — section de formulaire STANDARD (Design System). Réduit la charge cognitive :
// on regroupe les champs par thème (Informations principales / avancées / Configuration /
// Validation), avec titre + description optionnelle et repli possible pour l'avancé.
// La grille passe automatiquement à 1 colonne sur mobile (formulaire mobile ≠ desktop).
import React, { useState, useId } from 'react';
import './FormSection.css';

const FormSection = ({
  title,
  description,
  columns = 2,          // 1 ou 2 colonnes (desktop). Mobile = toujours 1.
  collapsible = false,
  defaultOpen = true,
  children,
  className = '',
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const bodyId = useId();

  // U-1 — quand la section est repliable, TOUTE la ligne d'en-tête est un bouton cliquable (pas
  // seulement le chevron), avec un chevron bien visible et un libellé accessible au clavier.
  const headContent = (
    <>
      <div className="form-section__titles">
        {title && <h3 className="form-section__title">{title}</h3>}
        {description && <p className="form-section__desc">{description}</p>}
      </div>
      {collapsible && (
        <span className={`form-section__chevron${open ? ' is-open' : ''}`} aria-hidden="true">▾</span>
      )}
    </>
  );

  return (
    <section className={`form-section ${className}`}>
      {collapsible ? (
        <button
          type="button"
          className="form-section__head form-section__head--toggle"
          aria-expanded={open}
          aria-controls={bodyId}
          onClick={() => setOpen((v) => !v)}
        >
          {headContent}
        </button>
      ) : (title && (
        <div className="form-section__head">{headContent}</div>
      ))}

      {(!collapsible || open) && (
        <div id={bodyId} className={`form-section__grid form-section__grid--cols${columns}`}>
          {children}
        </div>
      )}
    </section>
  );
};

export default FormSection;
